import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link, useHistory, useLocation } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"
import { useSelector } from 'react-redux';

import axios from "axios";
import { saveAs } from "file-saver";

import { contractCall, getAllbaroData, getEmitterAllbaroData } from "../../crud/auth.crud"
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Pagination from "pages/Custom/Pagination";

import Loading from "pages/Custom/Loading";

const AllbaroProcess = () => {

  const history = useHistory()
  const location = useLocation()

  const selector = useSelector(state => state);
  const queryParams = new URLSearchParams(location.search)
  const page = queryParams.get('page') || 1

  const [dataList, setDataList] = useState([])
  const [onUpload, setOnUpload] = useState(false);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [companyName, setCompanyName] = useState(location.state?.companyName || selector.auth.user.member_group?.[0]?.company_group?.name)
  const [detailType, setDetailType] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.company_detail?.[0]?.type || "")
  const [totalDataCount, setTotalDataCount] = useState(0)

  const getDataList = async () => {
    setOnUpload(true)

    const params = {
      page: page,
      company: companyId
    }

    const response = await getEmitterAllbaroData(params);
    setTotalDataCount(response.data.count || 0)
    if (response.status === 200) {
      const content = response.data?.results || [];
      setDataList(content)
    }
    setOnUpload(false)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  return (
    <Row>
      <Col md={12} lg={9} xl={6}>
        {/* Render Email SideBar */}
        {/* <EmailSideBar /> */}
        <div className="email-rightbar mb-3">
          <Card>
            <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>
              <div className="table-responsive">
                <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                  <thead className="chart-thead">
                    <tr>
                      <th scope="col" style={{ fontWeight: 600 }}>ID</th>
                      <th scope="col" style={{ fontWeight: 600 }}>거래처명</th>
                      <th scope="col" style={{ fontWeight: 600 }}>거래일자</th>
                      <th scope="col" style={{ fontWeight: 600 }}>차량번호</th>
                      <th scope="col" style={{ fontWeight: 600 }}>입고량(kg)</th>
                    </tr>
                  </thead>
                  <tbody className="chart-tbody">

                    {dataList.map((item, index) => {
                      return (
                        <tr key={item.id + '_' + index}>
                          <td>{item.id}</td>
                          <td>{item.company_from?.name}</td>
                          <td>{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}</td>
                          <td>{item.car_number}</td>
                          <td>{item.qty}</td>
                        </tr>
                      )
                    })}
                    {dataList.length === 0 &&
                      <tr >
                        <td scope="row" colSpan="7">데이터가 없습니다.</td>
                      </tr>
                    }

                  </tbody>
                </table>
              </div>
            </CardBody>

          </Card>
          <Pagination totalDataCount={totalDataCount} isLoading={onUpload} />
        </div>
      </Col>
      {onUpload && <Loading />}
    </Row>
  )
}

export default AllbaroProcess
